function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#0F1941",
  d: "M43.355 28.241l-3.623-6.186h-11.26l10.403 8.758-.001-.002c.665.648 1.66.936 2.63.668 1.426-.394 2.255-1.844 1.851-3.238",
  transform: "translate(0 8)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB511",
  d: "M46.864 19.85H37.09v-.307c0-8.337-4.461-15.62-11.1-19.54l.22-.003C16.304.002 8.115 7.434 6.787 17.088L.785 19.497C.307 19.71 0 20.19 0 20.718c0 .739.592 1.337 1.321 1.337h45.543c.601 0 1.09-.494 1.09-1.103s-.489-1.102-1.09-1.102",
  transform: "translate(0 8)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2175D9",
  d: "M37.163 19.691V20h8.812c0-11.046-8.854-20-19.776-20-.075 0-.15.002-.224.003C32.666 3.952 37.163 11.29 37.163 19.69",
  transform: "translate(0 8)"
})));
function SvgSectorBtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectorBtp);
export default __webpack_public_path__ + "static/media/SectorBTP.a20b68be.svg";
export { ForwardRef as ReactComponent };